<span
    class="availability-indicator"
    [class]="'availability-indicator ' + indicatorClass"
    role="img"
    [attr.aria-label]="label"
    [attr.title]="label">
    @if (hasQuantity) {
        <span class="availability-quantity label-medium" aria-hidden="true">{{ stock?.quantity }} q.ta</span>
    }
    <i [class]="iconClass" aria-hidden="true"></i>
</span>
